import { pages } from './pages';

export function findAdminPage(pageId = '') {
  const normalizedPageId = String(pageId || '').trim();
  for (const page of pages) {
    if (page.id === normalizedPageId) {
      return page;
    }
    const child = (page.children || []).find(item => item.id === normalizedPageId);
    if (child) {
      return child;
    }
  }
  return null;
}

export function isAdminPageId(pageId = '') {
  return Boolean(findAdminPage(pageId));
}
